import React from 'react';
import PropTypes from 'prop-types';
import './ProgressBar.less';


const ProgressBar = ({ show, percentage, clsName }) => {
  const showOrHide = (show) ? '' : ' hide';
  return (
    <div className={`react-progress-bar react-progress-bar-${showOrHide} ${clsName}`}>
      <div className="inner" style={{ width: `${percentage}%` }} />
    </div>
  );
};

ProgressBar.defaultProps = {
  show: false,
  clsName: '',
};

ProgressBar.propTypes = {
  show: PropTypes.bool,
  clsName: PropTypes.string,
  percentage: PropTypes.number.isRequired,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/common/ProgressBar/ProgressBar.js